import { render, staticRenderFns } from "./SequenceLogo.vue?vue&type=template&id=00669a26"
import script from "./SequenceLogo.vue?vue&type=script&lang=js"
export * from "./SequenceLogo.vue?vue&type=script&lang=js"
import style0 from "./SequenceLogo.vue?vue&type=style&index=0&id=00669a26&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports